import gql from 'graphql-tag';

const filteredFlatRatesQuery = gql`
  query filteredFlatRates(
    $auctionAccessNumber: Int!
    $miles: Int
    $dealerNumbers: [String]
    $psi: Int
    $daysSelected: Int
    $daysPsi: Int
    $govtLast4: String
    $productId: Int
  ) {
    apmsFlatRates(
      auctionAccessNumber: $auctionAccessNumber
      miles: $miles
      psi: $psi
      daysSelected: $daysSelected
      daysPsi: $daysPsi
      dealerNumbers: $dealerNumbers
      productId: $productId
    ) {
      dealerNo
      targetPrice
      id
      targetPrice360
      targetPrice360Psi
      targetPrice500
      targetPrice500Psi
    }
    buyerInformation(
      auctionAccessNumber: $auctionAccessNumber
      govtLast4: $govtLast4
    ) {
      id
      name
      emails
      cellPhone
    }
  }
`;

export default filteredFlatRatesQuery;
